import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import { listCustomers } from '../../utils/queries';

const PAGE_SIZE = 25;

export default function CustomersList() {
	const { activeStoreId } = useContext(MyContext);
	const [customers, setCustomers] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState('');

	useEffect(() => {
		setLoading(true);
		listCustomers({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			search: search || undefined,
			storeId: activeStoreId || undefined,
		}).then((result) => {
			if (result?.success) {
				setCustomers(result.data.customers);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, search, activeStoreId]);

	const columns = [
		{
			key: 'email',
			header: 'Email',
			render: (value, row) => (
				<Link to={`/customers/${row.customerId}`} className='text-black font-medium hover:underline'>
					{value}
				</Link>
			),
		},
		{
			key: 'firstName',
			header: 'Name',
			render: (value, row) => `${value || ''} ${row.lastName || ''}`.trim(),
		},
		{ key: 'company', header: 'Company' },
		{ key: 'externalCustomerId', header: 'External Customer ID' },
		{ key: 'erpContactId', header: 'ERP Customer #' },
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-6'>ERP Customers</h1>
			<p className='text-sm text-gray-500 mb-6 max-w-2xl'>
				ERP contacts. To view the stores registered user, see{' '}
				<Link to='/store-accounts' className='underline hover:text-black'>
				 Registered Users
				</Link>
				.
			</p>

			<div className='mb-5'>
				<label>Search</label>
				<div className='relative max-w-sm'>
					<Search className='pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400' />
					<input
						className='w-52 form-input pl-9'
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
							setPage(0);
						}}
					/>
				</div>
			</div>

			<DataTable columns={columns} data={customers} loading={loading} emptyHeading='No customers found' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
